
    document.addEventListener("DOMContentLoaded", function () {
        const applianceSelect = document.getElementById("appliance");
        const customWattageGroup = document.getElementById("custom-wattage-group");
        const calculateBtn = document.getElementById("calculate-btn");
        const resultsDiv = document.getElementById("results");

        // Show/hide custom wattage field
        applianceSelect.addEventListener("change", function () {
            if (this.value === "custom") {
                customWattageGroup.style.display = "block";
            } else {
                customWattageGroup.style.display = "none";
            }
        });

        // Calculate button click handler
        calculateBtn.addEventListener("click", function () {
            calculateCost();
        });

        // Also calculate when pressing Enter in input fields
        document.getElementById("usage").addEventListener("keypress", function (e) {
            if (e.key === "Enter") calculateCost();
        });

        document.getElementById("price").addEventListener("keypress", function (e) {
            if (e.key === "Enter") calculateCost();
        });

        document
                .getElementById("custom-wattage")
                .addEventListener("keypress", function (e) {
                    if (e.key === "Enter") calculateCost();
                });

        function calculateCost() {
            // Get appliance wattage
            let wattage;
            if (applianceSelect.value === "custom") {
                wattage = parseFloat(document.getElementById("custom-wattage").value);
                if (isNaN(wattage) || wattage <= 0) {
                    alert("Please enter a valid wattage");
                    return;
                }
            } else {
                wattage = parseFloat(applianceSelect.value);
            }

            // Get usage
            const usageInput = parseFloat(document.getElementById("electricity-usage").value);
            if (isNaN(usageInput) || usageInput < 0) {
                alert("Please enter a valid usage value");
                return;
            }

            const usageUnit = document.getElementById("usage-unit").value;
            let usageHours;
            if (usageUnit === "minutes") {
                usageHours = usageInput / 60;
            } else {
                usageHours = usageInput;
            }

            // Get price
            const price = parseFloat(document.getElementById("price").value);
            if (isNaN(price) || price < 0) {
                alert("Please enter a valid electricity price");
                return;
            }

            // Calculate kWh per day
            const kWhPerDay = (wattage * usageHours) / 1000;

            // Calculate costs
            const costPerHour = (wattage / 1000) * price;
            const costPerDay = kWhPerDay * price;
            const costPerMonth = costPerDay * 30;
            const costPerYear = costPerDay * 365;

            // Display results
            document.getElementById("cost-hour").textContent =
                    "$" + costPerHour.toFixed(2);
            document.getElementById("cost-day").textContent =
                    "$" + costPerDay.toFixed(2);
            document.getElementById("cost-month").textContent =
                    "$" + costPerMonth.toFixed(2);
            document.getElementById("cost-year").textContent =
                    "$" + costPerYear.toFixed(2);
            document.getElementById("kwh-day").textContent = kWhPerDay.toFixed(2);

            // Show results with animation
            resultsDiv.style.display = "block";
        }
    });

    document
            .getElementById("calculateButton")
            .addEventListener("click", function () {
                const length = parseFloat(document.getElementById("lighting-length").value);
                const width = parseFloat(document.getElementById("lighting-width").value);
                const height = parseFloat(document.getElementById("lighting-height").value);
                const lightType = document.getElementById("lightType").value;
                const usage = document.getElementById("usage").value;

                const lightLumens = {
                    "100-adjustable": 14000,
                    "150-adjustable": 21000,
                    "200-adjustable": 28000,
                    "240-adjustable": 33600,
                    "400-adjustable": 60000,
                    "150-hb-black": 24000,
                    "150-hb-white": 24000,
                    "200-hb-black": 32000,
                    "200-hb-white": 32000,
                    "240-hb-black": 36000,
                    "240-hb-white": 36000,
                    "300-hb": 42000,
                    "150-super": 24000,
                    "200-super": 32000,
                    "100-eco": 11000,
                    "150-eco": 16500,
                    "150-ufo": 16500,
                    "130-linear": 19500,
                    "210-linear": 31500,
                    "300-linear": 45000,
                };

                const luxValues = {
                    "Bedroom": 200,
                    "Living Room": 200,
                    "Kitchen": 500,
                    "Study": 750,
                    "Industrial": 750,
                    "Factory": 750,
                    "Bathroom": 500,
                    "Office Work Area": 500,
                    "Conference Room": 500,
                    "Reception Area": 300,
                    "Retail Stores": 1000,
                    "Restaurants": 100,
                    "Warehouse": 300,
                    "General Manufacturing": 500,
                    "Fine Work Inspection": 1000,
                    "Assembly Line": 750,
                    "Classrooms": 500,
                    "Laboratories": 1000,
                    "Hospital Wards": 300,
                    "Operating Rooms": 2000,
                    "Parking Lots": 100,
                    "Sidewalks": 200,
                    "Sports Fields": 1000,
                };

                if (
                        isNaN(length) ||
                        length <= 0 ||
                        isNaN(width) ||
                        width <= 0 ||
                        isNaN(height) ||
                        height <= 0
                ) {
                    document.getElementById("lighting-result").innerText =
                            "Please enter valid dimensions.";
                    return;
                }

                const lightChoice = document.getElementById("lightType").value;
                const usageChoice = document.getElementById("usage").value;

                const volume = length * width;
                const maxLux = luxValues[usageChoice];
                const totalLumensNeeded = (volume * maxLux) / 10;
                const lumensPerLight = lightLumens[lightChoice];

                let lightsNeeded = Math.ceil(totalLumensNeeded / lumensPerLight);

                const lightsFactor = {
                    10: 1.1,
                    15: 1.2,
                    20: 1.3,
                    25: 1.4,
                    30: 1.5,
                    35: 1.6,
                    40: 1.7,
                    45: 1.8,
                };

                const threshold = Object.keys(lightsFactor).find(
                        (key) => height >= key && height < parseInt(key) + 5
                );
                if (threshold) {
                    lightsNeeded = Math.ceil(lightsNeeded * lightsFactor[threshold]);
                }

                function isPrime(num) {
                    if (num <= 1) return false;
                    if (num === 2) return true;
                    for (let i = 2; i <= Math.sqrt(num); i++) {
                        if (num % i === 0) return false;
                    }
                    return true;
                }

                if (isPrime(Math.ceil(lightsNeeded))) {
                    lightsNeeded += 1;
                }

                document.getElementById(
                        "lighting-result"
                ).innerText = `Number of lights needed: ${lightsNeeded}`;

                // Show the product link button
                const productLinkButton = document.getElementById("productLinkButton");
                productLinkButton.style.display = "block";

                // Set the product link based on lightType
                const productLinks = {
                    "100-adjustable":
                            "https://yxllighting.com/products/high-bay-lights?variant=40845752434763",
                    "100-beta": "https://yxllighting.com/products/400w-high-bay-lights?variant=41823583797323",
                    "150-adjustable": "https://yxllighting.com/products/high-bay-led-lights?variant=41855256625227",
                    "150-hb-black":
                            "https://yxllighting.com/products/ufo-led-high-bay-lights?variant=41448117567563",
                    "150-hb-white": "https://yxllighting.com/products/led-high-bay-led-lights?variant=40852004962379",
                    "150-alpha":
                            "https://yxllighting.com/collections/warehouse-lighting",
                    "150-beta": "https://yxllighting.com/products/400w-high-bay-lights?variant=41855272419403",
                    "150-ufo": "https://yxllighting.com/products/ufo-led-high-bay-lights?variant=41448117567563",
                    "150-eco": "https://yxllighting.com/products/400w-high-bay-lights?variant=41855272419403",
                    "200-adjustable": "https://yxllighting.com/products/high-bay-led-lights?variant=41855256657995",
                    "200-hb-black": "https://yxllighting.com/products/ufo-led-high-bay-lights?variant=41837342294091",
                    "200-hb-white":
                            "https://yxllighting.com/products/led-high-bay-led-lights?variant=40852005027915",
                    "200-alpha": "https://yxllighting.com/collections/warehouse-lighting",
                    "240-adjustable": "https://yxllighting.com/products/high-bay-led-lights?variant=41855256690763",
                    "240-hb-black":
                            "https://yxllighting.com/products/ufo-led-high-bay-lights?variant=41837342425163",
                    "240-hb-white":
                            "https://yxllighting.com/products/led-high-bay-led-lights?variant=40852005093451",
                    "300-hb-black": "https://yxllighting.com/products/ufo-led-high-bay-lights?variant=41837342556235",
                    "300-adjustable": "https://yxllighting.com/products/400w-high-bay-lights?variant=41855273009227",
                    "400-adjustable":
                            "https://yxllighting.com/products/400w-high-bay-lights?variant=41855273205835",
                    "130-linear":
                            "https://yxllighting.com/products/linear-high-bay-shop-lights?variant=41846097477707",
                    "210-linear": "https://yxllighting.com/products/linear-high-bay-shop-lights?variant=41846097543243",
                    "300-linear": "https://yxllighting.com/products/linear-high-bay-shop-lights?variant=41846097608779",
                };

                if (productLinks && productLinks[lightType]) {
                    productLinkButton.href = productLinks[lightType];
                    productLinkButton.onclick = function () {
                        window.location.href = productLinks[lightType];
                    };
                } else {
                    console.error("Invalid lightType or productLinks");
                }
            });
